import { Capacitor } from '@capacitor/core'

const DEFAULT_NATIVE_CALLBACK = 'stepcare://auth-callback'
const DEFAULT_WEB_CALLBACK_PATH = '/auth-callback'

/**
 * OAuth / magic-link redirect target for the current platform.
 */
export function getAuthRedirectUrl(
  callbackPath = DEFAULT_WEB_CALLBACK_PATH,
  nativeCallbackUrl = DEFAULT_NATIVE_CALLBACK
): string {
  if (Capacitor.isNativePlatform()) {
    return nativeCallbackUrl
  }
  if (typeof window === 'undefined') {
    return callbackPath
  }
  return `${window.location.origin}${callbackPath}`
}
